import { Row } from 'antd'
import styled from 'styled-components'

const StyledPaddingTopRow = styled(Row)`
  padding-top: 1rem;
`

export default StyledPaddingTopRow
